<template>
  <div class="content conta">
    <h1><span><i class="fas fa-user-circle"></i> Usuários Frios - Download CSV</span></h1>
     <div class="mt-5">
      <div class="tab-pane fade show active" id="pills-notificacoes" role="tabpanel" aria-labelledby="pills-notificacoes-tab">
        <div>
          <a href="javascript:void(0)" class="btn btn-primary mr-3 mb-2 mb-md-0" @click="download()"><i class="fas fa-download"></i> Baixar CSV</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResetPasswordAPI from '@/api/reset-password-api'
import EmpresaUtils from '@/core/util/empresa-utils'

export default {
  name: 'DownloadLinksResetSenhasUsuariosFriosView',
  methods: {
    async download () {
      const loader = this.$loading.show()
      let response = await ResetPasswordAPI.downloadLinksResetSenhasUsuariosFrios()
      let headers = response.headers
      let blob = new Blob([response.data], { type: headers['content-type'] })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = EmpresaUtils.getEmpresa().empresa
      link.click()
      loader.hide()
    }
  }
}
</script>
